import "./image-upload-save-hint.css";

/**
 * Reminder shown after images are uploaded to the server but not yet
 * persisted on the parent entity (user must submit the form).
 */
export default function ImageUploadSaveHint({
    visible,
    plural = true,
    saveLabel = "Enregistrer"
}) {
    if (!visible) {
        return null;
    }
    const text = plural
        ? `Images chargées. Cliquez sur « ${saveLabel} » pour les enregistrer.`
        : `Image chargée. Cliquez sur « ${saveLabel} » pour l'enregistrer.`;
    return (
        <p className="image-upload-save-hint" role="status">
            {text}
        </p>
    );
}
